import { IsAmendment } from 'scenes/IO/helpers/IsAmendment';

export const GetIOEntityName = (data) => {
  return IsAmendment(data) ? 'Amendment' : 'IO';
};
